import React, { Component } from 'react';

class AudioPlayer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isPlaying: false
    };
    this.audioRef = React.createRef();
  }

  handlePlay = () => {
    this.setState({ isPlaying: true });
    this.audioRef.current.play();
  }

  handlePause = () => {
    this.setState({ isPlaying: false });
    this.audioRef.current.pause();
  }

  render() {
    const { isPlaying } = this.state;
    const { src } = this.props;
    return (
      <div className="audio-player" style={{"z-index": 999}}>
        <audio ref={this.audioRef} src={src} controls />
        {isPlaying
          ? <button onClick={this.handlePause} ></button>
          : <button onClick={this.handlePlay}></button>
        }
      </div>
    );
  }
}

export default AudioPlayer;
